module.exports = __webpack_public_path__ + "img/noauth-web-img.be9de69a.png";